define('uikit/views/table.remove',['require','exports','module','underscore','../elements/button','./table.selected'],function(require, exports, module){
  var _ = require('underscore');
  var ButtonView = require('../elements/button');
  var TableSelectedView = require('./table.selected');

  var TableRemoveView = TableSelectedView.extend({

    initialize: function() {
      TableSelectedView.prototype.initialize.apply(this, arguments);
      var buttonOptions = _.extend({}, this.buttonOptions, this.getOption('buttonOptions'));
      this.view = new ButtonView(_.extend({ circular: true, icon: 'remove', size: 'small' }, buttonOptions));
      this.view.$el.addClass('invertable');
      this.view.on('press', function() {
        var row = this.getRow();
        row.trigger('remove:model', this);
      }, this);
    }

  });

  module.exports = TableRemoveView;
});
